import FarmList from './farm-units.list';

export const FarmUnitStores = {
  list: FarmList,
};
